module.exports = __webpack_public_path__ + "static/icons/img-banner-prestamos-vida.a602082.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prestamos-vida/img-banner-prestamos-vida.svg
// module id = wmDE
// module chunks = 1